import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Healthcaremilo() {
  return (
    <section className="web_visibility p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center resp_order mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/hire-ios-app-developers/about_hire_ios.webp"
              alt="milo-mob-casestudy"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={809}
              height={451}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Addressing Your Needs with Skilled <span>iOS Developers</span>
            </h2>
            <p>
              Finding the right iOS app developers can be challenging. Our
              highly skilled remote iOS developers ensures you get proficient
              and reliable{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development">
                mobile app development{" "}
              </Link>
              tailored to your business needs. Whether you're a small startup or
              a large enterprise, our developers bring extensive technical
              expertise and creativity to every project.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Hire Now
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Healthcaremilo;
